export class RequestError extends Error {
  constructor(public response: Response, public status: number, message: string, public data?: Dictionary) {
    super(message);
    this.name = 'RequestError';
  }
}
